import { Grid, useMediaQuery, useTheme } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CAppSubTitle from '../../../app/components/CAppSubTitle';
import AppCustomIcon from '../../../app/features/icon/AppIcon';
import useInvestExpertises from '../../investor/hooks/expertise/useInvestExpertises';
import CDocumentExpertiseItem, { CDocumentExpertiseItemProps } from '../components/CDocumentExpertiseItem';
import IDocumentFile from '../interfaces/IDocumentFile';
import langDocumentFiles from '../langs/langDocumentFiles';

type VDocumentFilesDashboardExpertisesProps = {
	documentFiles: IDocumentFile[];
};

const VDocumentFilesDashboardExpertises = (props: VDocumentFilesDashboardExpertisesProps) => {
	const { documentFiles: DocumentFiles } = props;
	const { t } = useTranslation();

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const investExpertises = useInvestExpertises();

	const [investExpertisesDocumentStats, setInvestExpertisesDocumentStats] = useState<CDocumentExpertiseItemProps[]>();

	useEffect(() => {
		if (investExpertises && DocumentFiles) {
			const companyDocuments = DocumentFiles.filter((f) => f.company && !f.fund); // TODO: mettre isCompanyDocument dans le back
			const newInvestExpertisesDocumentStats: CDocumentExpertiseItemProps[] = [
				// Company documents
				{
					icon: <AppCustomIcon tag="company" />,
					name: t(langDocumentFiles.company_documents.tag),
					investmentTypeTag: 'company',
					nbDocumentFiles: companyDocuments.length,
					isCompanyDocument: true,
				},
				// Expertises documents
				...investExpertises
					.filter((expertise) => DocumentFiles.map((f) => f.fund?.typeTag).includes(expertise.tag))
					.map((expertise) => ({
						icon: expertise.icon,
						name: expertise.name,
						investmentTypeTag: expertise.tag,
						nbDocumentFiles: DocumentFiles.filter((x) => x.fund?.typeTag === expertise.tag).length,
						nbInvestFunds: _.uniqBy(
							DocumentFiles.filter((x) => x.fund?.typeTag === expertise.tag),
							'fund.id',
						).length,
					})),
			];

			setInvestExpertisesDocumentStats(newInvestExpertisesDocumentStats);
		}
	}, [investExpertises, DocumentFiles, t]);

	return (
		<>
			<CAppSubTitle
				title={t(langDocumentFiles.document_distribution.tag)}
				icon={<AppCustomIcon tag="expertises" />}
			/>
			{!isMobile ? (
				<Grid container spacing={3}>
					{investExpertisesDocumentStats &&
						investExpertisesDocumentStats.map(
							(investExpertisesDocumentStat: CDocumentExpertiseItemProps, index: number) => {
								return (
									!!investExpertisesDocumentStat.nbDocumentFiles && (
										<Grid key={index} item xs={12} md={6} lg={4}>
											<CDocumentExpertiseItem
												icon={investExpertisesDocumentStat.icon}
												name={investExpertisesDocumentStat.name}
												investmentTypeTag={investExpertisesDocumentStat.investmentTypeTag}
												nbDocumentFiles={investExpertisesDocumentStat.nbDocumentFiles}
												nbInvestFunds={investExpertisesDocumentStat.nbInvestFunds}
												isCompanyDocument={investExpertisesDocumentStat.isCompanyDocument}
											/>
										</Grid>
									)
								);
							},
						)}
				</Grid>
			) : (
				<>
					<div
						style={{
							height: '110px',
							overflowX: 'scroll',
							display: 'flex',
							flexWrap: 'wrap',
							flexDirection: 'column',
						}}
					>
						{investExpertisesDocumentStats &&
							investExpertisesDocumentStats.map(
								(investExpertisesDocumentStat: CDocumentExpertiseItemProps, index: number) => {
									return (
										<div
											key={index}
											style={{
												width: investExpertises.length > 1 ? '90%' : '100%',
												marginRight: investExpertises.length > 1 ? '30px' : '0px',
											}}
										>
											{!!investExpertisesDocumentStat.nbDocumentFiles && (
												<CDocumentExpertiseItem
													icon={investExpertisesDocumentStat.icon}
													name={investExpertisesDocumentStat.name}
													investmentTypeTag={investExpertisesDocumentStat.investmentTypeTag}
													nbDocumentFiles={investExpertisesDocumentStat.nbDocumentFiles}
													nbInvestFunds={investExpertisesDocumentStat.nbInvestFunds}
													isCompanyDocument={investExpertisesDocumentStat.isCompanyDocument}
												/>
											)}
										</div>
									);
								},
							)}
					</div>
				</>
			)}
		</>
	);
};

export default VDocumentFilesDashboardExpertises;
